import React from "react";
import AccountInfo from "./AccountInfo";
import LoginCred from "./LoginCred";
import Social from "./Social";

const Account = () => {
  document.getElementsByTagName("title")[0].innerHTML = "account";

  return (
    <div
      className="app-view-body"
      // style={{ margin: "80px auto 80px" }}
    >
      <div
        className="uk-width-5-6@s uk-width-2-3@m"
        style={{
          margin: "auto",
          width: "95%",
        }}
      >
        <h4 className="app-text">Account</h4>
        <div>
          <ul
            id="account-tab"
            className="uk-tab"
            data-uk-tab="connect: #account-content; animation: uk-animation-slide-left-medium, uk-animation-slide-right-medium"
          >
            <li>
              <a href="#!">Info</a>
            </li>
            <li>
              <a href="#!">Login</a>
            </li>
            <li>
              <a href="#!">Social</a>
            </li>
            <li>
              <a href="#!">Promotion</a>
            </li>
          </ul>
          <ul id="account-content" className="uk-switcher uk-margin">
            <li id="acc-info">
              <AccountInfo />
            </li>
            <li id="credentials">
              <LoginCred />
            </li>
            <li>
              <Social />
            </li>
            <li>Promo</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Account;
